import comp from "./PaginationLoader";
export default comp;
